import { EmojiEvents, Lock } from '@mui/icons-material';
import { Chip, Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { observer } from 'mobx-react';
import React from 'react';
import { Processo } from '../../modelo';
import ProcessoService from '../../services/ProcessoService';
import RouterStore from '../../store/RouterStore';

interface IPropsLabelNumeroProcessoCompleto {
    processo: Processo;
    elipses?: boolean;
    quebrarLinha?: boolean;
}

const COR_ESMAECER = 'orange';

class LabelNumeroProcessoCompleto extends React.Component<IPropsLabelNumeroProcessoCompleto> {
    get deveEsmaecer() {
        return ProcessoService.deveEsmaecer(this.props.processo)
    }

    get cor() {
        const corVermelha = this.deveEsmaecer ? 200 : 900;
        const corEsmaecer = this.deveEsmaecer && COR_ESMAECER;
        return (this.props.processo.segredoDeJustica && red[corVermelha]) || (corEsmaecer);
    }

    get metasProcesso(): string[] {
        const metas = new Set<string>();

        const adicionarMeta = (nome?: string, indicador: boolean = false) => {
            const nomeNormalizado = nome?.trim().toUpperCase();
            if (nomeNormalizado === 'META CNJ') {
                metas.add('Meta CNJ');
            }
            if (nomeNormalizado === 'META 2' && indicador) {
                metas.add('Meta 2');
            }
        }

        this.props.processo.etiquetas?.forEach(etiqueta => adicionarMeta(etiqueta.texto));
        // Inclui os chips da origem PJe, apresentados como indicadores com isEtiqueta: true.
        this.props.processo.indicadores?.forEach(indicador =>
            adicionarMeta(indicador.descricao, true)
        );

        return Array.from(metas);
    }

    tooltipMeta(meta: string): string {
        if (meta === 'Meta 2') {
            return 'Processos pendentes de julgamento até 31/12/2020';
        }
        return '';
    }

    handleClickMeta = (event: React.MouseEvent) => {
        event.stopPropagation();
    }

    render() {

        const labelTooltip = this.deveEsmaecer ?
            (RouterStore.isEscaninhoAssinatura ?
                'Processo fora do gabinete.'
                :
                'Processo fora do gabinete. Favor verificar no sistema de origem'
            )
            :
            this.props.processo.numeroProcesso;
        return (
            <>
                <span style={{
                    minWidth: this.props.quebrarLinha ? 0 : '19em',
                    maxWidth: this.props.quebrarLinha ? '100%' : undefined,
                    display: 'inline-flex',
                    flexWrap: this.props.quebrarLinha ? 'wrap' : 'nowrap',
                    alignItems: 'center',
                    gap: '6px'
                }}>
                    <Tooltip title={labelTooltip} className='sumario-processo-numero'>
                        <Typography style={{
                            color: this.cor,
                            overflow: this.props.elipses && 'hidden',
                            width: this.props.elipses && '30ch',
                            textOverflow: this.props.elipses && 'ellipsis'
                        }}
                            component='span'
                        >
                            {this.props.processo.numeroProcesso}
                        </Typography>
                    </Tooltip>
                    {this.props.processo.segredoDeJustica &&
                        <Tooltip title='Processo em segredo de justiça'>
                            <Lock style={{ color: this.cor }} />
                        </Tooltip>
                    }
                    {this.metasProcesso.map(meta =>
                        <Tooltip key={meta} title={this.tooltipMeta(meta)}>
                            <Chip
                                icon={<EmojiEvents />}
                                label={meta}
                                size='small'
                                onClick={this.handleClickMeta}
                                sx={{
                                    flexShrink: 0,
                                    height: 20,
                                    backgroundColor: '#f6c343',
                                    border: '1px solid #c69214',
                                    color: '#4a3200',
                                    cursor: 'default',
                                    fontWeight: 700,
                                    '&:hover': {
                                        backgroundColor: '#f6c343',
                                        cursor: 'default'
                                    },
                                    '& .MuiChip-icon': {
                                        color: '#7a5200',
                                        fontSize: 15,
                                        ml: '5px',
                                        cursor: 'default'
                                    },
                                    '& .MuiChip-label': {
                                        px: '6px',
                                        cursor: 'default'
                                    }
                                }}
                            />
                        </Tooltip>
                    )}
                </span>
            </>
        );
    }
}

export default observer(LabelNumeroProcessoCompleto);
